module.exports = __webpack_public_path__ + "media/images/categories/carousel/society-and-the-wider-world-e5efbe9f9d3d267cf4f9950c9b92f3b8.jpg";